import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getJobRequestOperasional = createAsyncThunk(
    "jobRequestOperasional/get",
    async ({start, count, search, jenis}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        formData.append("jenis", jenis);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getService',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertJobRequestOperasional = createAsyncThunk(
    "jobRequestOperasional/insert",
    async ({QuatationNo, JettyID, VesselName, DateArrival, DateDepature, Remarks}, thunkAPI) => {
        let formData = new FormData();
        formData.append("Jenis", "Vessel");
        formData.append("QuatationNo", QuatationNo);
        formData.append("JettyID", JettyID);
        formData.append("VesselName", VesselName);
        formData.append("DateArrival", DateArrival);
        formData.append("DateDepature", DateDepature);
        formData.append("StartTime", '01:37:04');
        formData.append("EndTime", '01:57:04');
        formData.append("Remarks", Remarks);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertService',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    errorMessage: "",
    homeData: {},
};

export const jobRequestOperasionalSlice = createSlice({
    name: "jobRequestOperasional",
    initialState,
    reducers: {},
    extraReducers: {

        [getJobRequestOperasional.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getJobRequestOperasional.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getJobRequestOperasional.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertJobRequestOperasional.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertJobRequestOperasional.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertJobRequestOperasional.pending]: (state) => {
            state.isInsertFetching = true;
        }
    },
});


export const jobRequestOperasionalSelector = (state) => state.jobRequestOperasional;
